/* Cãomigo — lógica da página "taca" (igual à do Claude Design). Precisa de cmg-dc.js antes. */
(function () {
class Component extends DCLogic {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.state || {}, {
      img: 0, open: {}, cart: 0, added: false, par: false, bump: false, menu: false,
      seen: {}, armed: false, bar: false, live: '', hint: true
    }, this.demoState());
    var self = this;
    this.setRoot = function (el) { self.rootEl = el; };
    this.setCv = function (el) { self.cv = el; };
    this.setCta = function (el) { self.ctaEl = el; };
    ['add', 'addPar', 'toggleMenu', 'dmDown', 'dmMove', 'dmUp', 'dmKey', 'tick'].forEach(function (k) { if (self[k]) self[k] = self[k].bind(self); });
    this.rowT = {};
    ["lavar", "caixa", "envio"].forEach(function (id) { self.rowT[id] = function () { self.toggle(id); }; });
    this.picks = [0, 1, 2, 3].map(function (i) { return function () { self.setState({ img: i }); }; });
    this.GAL = [{"t": "Verde Estrada.", "d": "Corpo e mosquetão verdes, aro preto.", "alt": "Taça dobrável Verde Estrada, aberta."}, {"t": "Na paragem.", "d": "Cerca de 350 ml, o que chega para matar a sede.", "alt": "Cão a beber da taça verde junto a um lago, com o dono agachado ao lado."}, {"t": "O aro e os foles.", "d": "Aro rígido por fora, silicone que dobra por dentro.", "alt": "Detalhe do aro rígido, dos foles de silicone e do mosquetão."}, {"t": "Dobrada.", "d": "Fica com cerca de 1,5 cm e cabe na palma da mão.", "alt": "Taça dobrada na palma da mão, num trilho de pinhal."}];
    this.dv = {};
    this.demoInit();
  }

  /* ---------- UI ---------- */
  toggle(id) { var o = Object.assign({}, this.state.open); o[id] = !o[id]; this.setState({ open: o }); }
  toggleMenu() { this.setState({ menu: !this.state.menu }); }
  add() {
    var self = this;
    this.setState({ cart: this.state.cart + 1, added: true, bump: true, live: "Taça dobrável de silicone adicionada ao carrinho." });
    clearTimeout(this._tA); clearTimeout(this._tB);
    this._tA = setTimeout(function () { self.setState({ added: false }); }, 1800);
    this._tB = setTimeout(function () { self.setState({ bump: false }); }, 460);
  }
  addPar() {
    if (this.state.par) return;
    var self = this;
    this.setState({ cart: this.state.cart + 1, par: true, bump: true, live: "Forra de porta-bagagens adicionada ao carrinho." });
    clearTimeout(this._tB);
    this._tB = setTimeout(function () { self.setState({ bump: false }); }, 460);
  }

  componentDidMount() {
    var self = this;
    this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var root = this.rootEl;
    var scrolls = document.documentElement.scrollHeight > (window.innerHeight || 0) + 80;
    if (root && scrolls && 'IntersectionObserver' in window && !this.reduce) {
      var vh = window.innerHeight || 800, seen = {};
      var els = root.querySelectorAll('[data-rv]');
      this.io = new IntersectionObserver(function (es) {
        var add = {}, n = 0;
        es.forEach(function (e) { if (e.isIntersecting) { add[e.target.getAttribute('data-rv')] = true; self.io.unobserve(e.target); n++; } });
        if (n) self.setState(function (s) { return { seen: Object.assign({}, s.seen, add) }; });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.top < vh * 0.92) seen[els[i].getAttribute('data-rv')] = true; else this.io.observe(els[i]);
      }
      this.setState({ seen: seen, armed: true });
    }
    if (this.ctaEl && 'IntersectionObserver' in window) {
      this.io2 = new IntersectionObserver(function (es) {
        var e = es[0]; var off = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (off !== self.state.bar) self.setState({ bar: off });
      }, { threshold: 0 });
      this.io2.observe(this.ctaEl);
    }
    this.setupCv();
  }
  componentWillUnmount() {
    if (this.io) this.io.disconnect();
    if (this.io2) this.io2.disconnect();
    if (this.ro) this.ro.disconnect();
    if (this.onWin) window.removeEventListener('resize', this.onWin);
    if (this.raf) cancelAnimationFrame(this.raf);
    var tw = this._tw || {}; for (var k in tw) cancelAnimationFrame(tw[k]);
    clearTimeout(this._tA); clearTimeout(this._tB);
  }

  /* ---------- palco do momento de assinatura ---------- */
  ease(x) {
    var x1 = .22, y1 = .61, x2 = .36, y2 = 1, t = x;
    for (var i = 0; i < 7; i++) {
      var bx = 3 * x1 * t * (1 - t) * (1 - t) + 3 * x2 * t * t * (1 - t) + t * t * t - x;
      var d = 3 * x1 * (1 - t) * (1 - t) + 6 * (x2 - x1) * t * (1 - t) + 3 * (1 - x2) * t * t;
      if (Math.abs(d) < 1e-6) break; t = Math.max(0, Math.min(1, t - bx / d));
    }
    return 3 * y1 * t * (1 - t) * (1 - t) + 3 * y2 * t * t * (1 - t) + t * t * t;
  }
  tween(key, to, ms, done) {
    var self = this, from = this.dv[key], tw = (this._tw = this._tw || {});
    cancelAnimationFrame(tw[key]);
    if (this.reduce || from === to) { this.dv[key] = to; this.changed(); if (done) done(); return; }
    var t0 = 0;
    var f = function (now) {
      if (!t0) t0 = now;
      var k = Math.min(1, (now - t0) / ms);
      self.dv[key] = from + (to - from) * self.ease(k); self.changed();
      if (k < 1) tw[key] = requestAnimationFrame(f); else if (done) done();
    };
    tw[key] = requestAnimationFrame(f);
  }
  stopTween(key) { var tw = this._tw || {}; cancelAnimationFrame(tw[key]); }
  changed() { this.kick(); this.status(); }
  kick() { if (!this.raf) this.raf = requestAnimationFrame(this.tick); }
  tick() { this.raf = 0; this.draw(); }
  setupCv() {
    var cv = this.cv; if (!cv || !cv.getContext) return;
    this.ctx = cv.getContext('2d');
    var self = this;
    this.fit();
    if (window.ResizeObserver) { this.ro = new ResizeObserver(function () { self.fit(); }); this.ro.observe(cv); }
    else { this.onWin = function () { self.fit(); }; window.addEventListener('resize', this.onWin); }
    this.status();
  }
  fit() {
    var cv = this.cv; if (!cv) return;
    var w = cv.clientWidth, h = cv.clientHeight; if (!w || !h) return;
    var d = Math.min(2, window.devicePixelRatio || 1);
    this.W = w; this.H = h; this.dpr = d;
    cv.width = Math.round(w * d); cv.height = Math.round(h * d);
    var vb = this.VB || [0, 0, this.DW, this.DH], cw = vb[2] - vb[0], ch = vb[3] - vb[1];
    var s = Math.min(w / cw, h / ch);
    this.s = s; this.ox = (w - cw * s) / 2 - vb[0] * s; this.oy = (h - ch * s) / 2 - vb[1] * s;
    this.draw();
  }
  begin() {
    var c = this.ctx; if (!c || !this.W) return null;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.clearRect(0, 0, this.W * this.dpr, this.H * this.dpr);
    c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    c.fillStyle = this.BG; c.fillRect(0, 0, this.W, this.H);
    var d = this.dpr * this.s;
    c.setTransform(d, 0, 0, d, this.dpr * this.ox, this.dpr * this.oy);
    return c;
  }
  scene() { var d = this.dpr * this.s; this.ctx.setTransform(d, 0, 0, d, this.dpr * this.ox, this.dpr * this.oy); }
  label(x, y, txt, o) {
    o = o || {};
    var c = this.ctx, px = this.ox + x * this.s, py = this.oy + y * this.s, fs = o.size || Math.max(12, Math.min(15, 14 * this.s * 1.25));
    c.save(); c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    c.font = (o.weight || 600) + ' ' + fs + 'px Inter, -apple-system, "Segoe UI", sans-serif';
    c.textAlign = o.align || 'center'; c.textBaseline = 'middle';
    if (o.rot) { c.translate(px, py); c.rotate(o.rot); px = 0; py = 0; }
    c.globalAlpha = o.alpha == null ? 1 : o.alpha;
    if (o.bg) {
      var m = c.measureText(txt).width, pw = 7, ph = fs * .72;
      var bx = o.align === 'left' ? px - pw : (o.align === 'right' ? px - m - pw : px - m / 2 - pw);
      c.fillStyle = o.bg; this.rr(c, bx, py - ph, m + pw * 2, ph * 2, 5); c.fill();
    }
    c.fillStyle = o.color || '#2B2A28'; c.fillText(txt, px, py);
    c.restore();
  }
  rr(c, x, y, w, h, r) {
    var rs = typeof r === 'number' ? [r, r, r, r] : r;
    c.beginPath(); c.moveTo(x + rs[0], y); c.lineTo(x + w - rs[1], y); c.quadraticCurveTo(x + w, y, x + w, y + rs[1]);
    c.lineTo(x + w, y + h - rs[2]); c.quadraticCurveTo(x + w, y + h, x + w - rs[2], y + h); c.lineTo(x + rs[3], y + h);
    c.quadraticCurveTo(x, y + h, x, y + h - rs[3]); c.lineTo(x, y + rs[0]); c.quadraticCurveTo(x, y, x + rs[0], y); c.closePath();
  }
  poly(c, pts) { c.beginPath(); c.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) c.lineTo(pts[i][0], pts[i][1]); c.closePath(); }
  quilt(c, x0, y0, x1, y1, step, col) {
    c.save(); c.strokeStyle = col || 'rgba(255,255,255,.075)'; c.lineWidth = 1.2; c.beginPath();
    var h = y1 - y0;
    for (var i = x0 - h; i < x1 + h; i += step) { c.moveTo(i, y0); c.lineTo(i + h, y1); c.moveTo(i, y1); c.lineTo(i + h, y0); }
    c.stroke(); c.restore();
  }
  dim(c, x0, y0, x1, y1, col) {
    c.save(); c.strokeStyle = col || '#6E6961'; c.lineWidth = 1.5; c.beginPath(); c.moveTo(x0, y0); c.lineTo(x1, y1);
    var a = Math.atan2(y1 - y0, x1 - x0), nx = -Math.sin(a) * 7, ny = Math.cos(a) * 7;
    c.moveTo(x0 - nx, y0 - ny); c.lineTo(x0 + nx, y0 + ny); c.moveTo(x1 - nx, y1 - ny); c.lineTo(x1 + nx, y1 + ny); c.stroke(); c.restore();
  }
  pt(e) { var b = this.cv.getBoundingClientRect(); return { x: ((e.clientX - b.left) - this.ox) / this.s, y: ((e.clientY - b.top) - this.oy) / this.s }; }
  cl(v, a, b) { return Math.max(a, Math.min(b, v)); }
  lerp(a, b, t) { return a + (b - a) * t; }
  num(v, d) { return v.toFixed(d == null ? 1 : d).replace('.', ','); }
  noHint() { if (this.state.hint) this.setState({ hint: false }); }
  say(m, alerta) { if (m !== this.state.dmMsg || !!alerta !== !!this.state.dmAlerta) this.setState({ dmMsg: m, dmAlerta: !!alerta, stF: !this.state.stF }); }


  demoState() { return { dmMsg: '', dmAlerta: false, cor: 'verde', agua: false, dob: false }; }
  demoInit() {
    this.DW = 800; this.DH = 550; this.BG = '#F7F5F1'; this.VB = [196, 150, 790, 486];
    this.dv = { t: 0, w: 0 };
    var self = this;
    this.corVerde = function () { self.setState({ cor: 'verde', img: 0 }, function () { self.kick(); }); };
    this.corPreto = function () { self.setState({ cor: 'preto', img: 0 }, function () { self.kick(); }); };
    this.toggleDob = function () {
      self.noHint();
      if (self.dv.t < .5) { if (self.dv.w > .01) { self.spilled = true; self.tween('w', 0, 300); } self.tween('t', 1, 1000); }
      else { self.spilled = false; self.tween('t', 0, 1000); }
    };
    this.toggleAgua = function () {
      self.noHint(); self.spilled = false;
      if (self.dv.w > .5) self.tween('w', 0, 500);
      else { var fill = function () { self.tween('w', 1, 900); }; if (self.dv.t > .02) self.tween('t', 0, 700, fill); else fill(); }
    };
  }
  draw() {
    var c = this.begin(); if (!c) return;
    var t = this.dv.t, wv = this.dv.w, verde = this.state.cor !== 'preto';
    var body = verde ? '#2F5D50' : '#2E2D2B', bodyL = verde ? '#437A6A' : '#4A4845', bodyD = verde ? '#22453B' : '#1B1A19', rim = '#1E1D1C', rimL = '#56534F', mq = verde ? '#3C7A67' : '#3A3936';
    var U = 26, cx = 400, yb = 412, hcm = 5 - 3.5 * t, h = hcm * U, yr = yb - h;
    var rb = 4.5 * U, rt = 6.1 * U, rr = 6.5 * U, e = .2;
    c.fillStyle = 'rgba(43,42,40,.10)'; c.beginPath(); c.ellipse(cx + 8, yb + 8, rr * 1.02, rr * e * 1.1, 0, 0, Math.PI * 2); c.fill();
    var n = 4, pts = [], i;
    for (i = 0; i <= n; i++) { var f = i / n, bul = (i % 2 ? 1 : 0) * (4 + 12 * t); pts.push({ y: yb - h * f, r: rb + (rt - rb) * f + bul }); }
    c.fillStyle = body; c.beginPath();
    for (i = 0; i <= n; i++) { if (i === 0) c.moveTo(cx - pts[i].r, pts[i].y); else c.lineTo(cx - pts[i].r, pts[i].y); }
    for (i = n; i >= 0; i--) c.lineTo(cx + pts[i].r, pts[i].y);
    c.closePath(); c.fill();
    c.beginPath(); c.ellipse(cx, yb, rb, rb * e, 0, 0, Math.PI); c.fill();
    for (i = 1; i < n; i++) { var p = pts[i]; c.strokeStyle = i % 2 ? bodyL : bodyD; c.lineWidth = i % 2 ? 2.5 : 2; c.beginPath(); c.ellipse(cx, p.y, p.r, p.r * e, 0, 0, Math.PI); c.stroke(); }
    c.fillStyle = bodyD; c.beginPath(); c.ellipse(cx, yr, rt, rt * e, 0, 0, Math.PI * 2); c.fill();
    if (wv > .01) {
      c.save(); c.globalAlpha = wv; c.fillStyle = '#CFDCD8'; c.beginPath(); c.ellipse(cx, yr + 7, rt * .88, rt * e * .8, 0, 0, Math.PI * 2); c.fill();
      c.strokeStyle = 'rgba(255,255,255,.75)'; c.lineWidth = 2; c.beginPath(); c.ellipse(cx - 30, yr + 3, 46, 6, 0, Math.PI * 1.1, Math.PI * 1.9); c.stroke(); c.restore();
    }
    c.strokeStyle = rim; c.lineWidth = 13; c.beginPath(); c.ellipse(cx, yr, rr - 6, (rr - 6) * e, 0, 0, Math.PI * 2); c.stroke();
    c.strokeStyle = rimL; c.lineWidth = 2; c.beginPath(); c.ellipse(cx, yr - 3, rr - 6, (rr - 6) * e, 0, Math.PI * 1.05, Math.PI * 1.95); c.stroke();
    var tx = cx + rr - 2; c.fillStyle = rim; this.rr(c, tx - 4, yr - 7, 24, 14, 4); c.fill();
    c.strokeStyle = mq; c.lineWidth = 6; c.lineJoin = 'round'; c.beginPath(); c.moveTo(tx + 20, yr); c.lineTo(tx + 40, yr - 6); c.quadraticCurveTo(tx + 62, yr - 4, tx + 60, yr + 24); c.lineTo(tx + 50, yr + 58); c.quadraticCurveTo(tx + 38, yr + 70, tx + 30, yr + 52); c.lineTo(tx + 22, yr + 6); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,.35)'; c.lineWidth = 2; c.beginPath(); c.moveTo(tx + 27, yr + 10); c.lineTo(tx + 33, yr + 44); c.stroke();
    var dx = cx + rr + 108;
    this.dim(c, dx, yb, dx, yr);
    this.label(dx + 14, (yb + yr) / 2, '≈ ' + this.num(hcm, 1) + ' cm', { align: 'left' });
    var ty = yr - rr * e - 34;
    this.dim(c, cx - rr, ty, cx + rr, ty); this.label(cx, ty, '≈ 13 cm', { bg: '#F7F5F1' });
    this.dim(c, cx - rb, yb + 50, cx + rb, yb + 50); this.label(cx, yb + 50, '≈ 9 cm', { bg: '#F7F5F1' });
  }
  status() {
    var t = this.dv.t, w = this.dv.w, m;
    if (t > .96) m = 'Dobrada: cerca de 1,5 cm. Cabe no bolso da porta.';
    else if (t < .04) m = w > .5 ? 'Aberta e cheia: cerca de 350 ml.' : 'Aberta: cerca de 5 cm de altura. Fica de pé sozinha.';
    else m = this.spilled ? 'Despejaste a água. Dobra-se vazia.' : 'A dobrar pelos foles.';
    this.say(m, false);
    var dob = t >= .5, agua = w >= .5;
    if (dob !== this.state.dob || agua !== this.state.agua) this.setState({ dob: dob, agua: agua });
  }
  dmDown(e) { if (!this.W) return; try { this.cv.setPointerCapture(e.pointerId); } catch (x) {} this.drag = true; this.p0 = this.pt(e); this.t0 = this.dv.t; this.stopTween('t'); this.noHint(); }
  dmMove(e) {
    if (!this.drag) return; var p = this.pt(e), t = this.cl(this.t0 + (p.y - this.p0.y) / 110, 0, 1);
    if (t > this.dv.t && this.dv.w > .01) { this.spilled = true; this.tween('w', 0, 300); }
    this.dv.t = t; this.changed();
  }
  dmUp() { if (!this.drag) return; this.drag = false; var t = this.dv.t; if (t > .02 && t < .98) this.tween('t', t >= .5 ? 1 : 0, 450); }
  dmKey(e) {
    var k = e.key, d = 0;
    if (k === 'ArrowDown') d = .1; else if (k === 'ArrowUp') d = -.1;
    else if (k === 'Enter' || k === ' ') { e.preventDefault(); this.toggleDob(); return; } else return;
    e.preventDefault(); this.stopTween('t'); this.noHint(); this.dv.t = this.cl(this.dv.t + d, 0, 1); this.changed();
  }
  demoVals(v) {
    var s = this.state, verde = s.cor !== 'preto', on0 = s.img === 0;
    v.toggleDob = this.toggleDob; v.dobLabel = s.dob ? 'Abrir a taça' : 'Dobrar a taça';
    v.toggleAgua = this.toggleAgua; v.aguaLabel = s.agua ? 'Despejar' : 'Encher de água';
    v.corVerde = this.corVerde; v.corPreto = this.corPreto;
    v.swV = verde ? 'swb sel' : 'swb'; v.swVp = verde ? 'true' : 'false';
    v.swP = verde ? 'swb' : 'swb sel'; v.swPp = verde ? 'false' : 'true';
    v.corNome = verde ? 'Verde Estrada' : 'Preto';
    v.galV = { c: verde && on0 ? 'ct on' : 'ct', a: verde && on0 ? 'Taça dobrável Verde Estrada, aberta, com mosquetão verde.' : '', th: verde ? 'ct' : 'ct hid' };
    v.galP = { c: !verde && on0 ? 'ct on' : 'ct', a: !verde && on0 ? 'Taça dobrável preta, aberta, com mosquetão preto.' : '', th: verde ? 'ct hid' : 'ct' };
    v.detV = verde ? 'ct' : 'ct hid'; v.detP = verde ? 'ct hid' : 'ct';
    if (on0) { v.capT = verde ? 'Verde Estrada.' : 'Preto.'; v.capD = verde ? 'Corpo e mosquetão verdes, aro preto.' : 'Tudo preto, aro incluído.'; }
    return v;
  }


  renderVals() {
    var s = this.state, self = this;
    var gal = {};
    this.GAL.forEach(function (g, i) {
      var on = i === s.img;
      gal['a' + i] = on ? g.alt : ''; gal['c' + i] = on ? 'on' : '';
      gal['t' + i] = on ? 'th sel' : 'th'; gal['p' + i] = on ? 'true' : 'false';
      gal['k' + i] = self.picks[i];
    });
    var cur = this.GAL[s.img];
    var rvc = function (k) { return !s.armed ? '' : (s.seen[k] ? 'rv in' : 'rv'); };
    var o = s.open, rows = {};
    for (var id in this.rowT) { rows[id] = { cls: o[id] ? 'row is-open' : 'row', exp: o[id] ? 'true' : 'false', t: this.rowT[id] }; }
    var v = {
      yes: true, logoH: 40, logoFt: 40,
      preco: 11.9, precoPar: 54.9, precoCapa: 39.9, precoRede: 89, precoForra: 54.9, precoCinto: 15.9, precoTaca: 11.9,
      feats: ["Dobra até cerca de 1,5 cm e cabe no bolso da porta", "Aro rígido: fica de pé sozinha e segura a água", "Silicone de grau alimentar, com mosquetão de alumínio"],
      trust: [{"icone": "envio", "texto": "Envio grátis"}, {"icone": "devolucao", "texto": "Devolução em 14 dias"}, {"icone": "prazo", "texto": "10 a 15 dias úteis"}],
      specs: [{"rotulo": "Capacidade", "valor": "Cerca de 350 ml"}, {"rotulo": "Aro (aberta)", "valor": "Cerca de 13 cm"}, {"rotulo": "Altura (aberta)", "valor": "Cerca de 5 cm"}, {"rotulo": "Dobrada", "valor": "Cerca de 1,5 cm"}, {"rotulo": "Material", "valor": "Silicone de grau alimentar, aro rígido"}, {"rotulo": "Cor", "valor": "Verde Estrada ou Preto, aro preto"}],
      factos: [{"titulo": "Envio grátis", "texto": "Para Portugal e 13 países da UE, sem mínimo."}, {"titulo": "10 a 15 dias úteis", "texto": "Sai de armazém internacional."}, {"titulo": "Devolução em 14 dias", "texto": "Sem justificação. Trocamos ou devolvemos o dinheiro."}, {"titulo": "Resposta em 1 dia útil", "texto": "caomigo.pt@gmail.com"}],
      gal: gal, capT: cur.t, capD: cur.d,
      ctaLabel: s.added ? 'Adicionado ao carrinho' : 'Adicionar ao carrinho',
      ctaShort: s.added ? 'Adicionado' : 'Adicionar ao carrinho', ctaCls: s.added ? 'cta-l on' : 'cta-l', added: s.added,
      parLabel: s.par ? "Forra adicionada" : "Adicionar a forra",
      add: this.add, addPar: this.addPar, liveMsg: s.live,
      hasCart: s.cart > 0, cart: s.cart, bdgCls: s.bump ? 'bdg bump' : 'bdg',
      cartLabel: s.cart > 0 ? 'Carrinho, ' + s.cart + (s.cart === 1 ? ' artigo' : ' artigos') : 'Carrinho, vazio',
      menuExp: s.menu ? 'true' : 'false', toggleMenu: this.toggleMenu, mnavCls: s.menu ? 'mnav is-open' : 'mnav',
      rows: rows,
      rv: { chips: rvc('chips'), foto: rvc('foto'), demo: rvc('demo'), ph: rvc('ph'), passos: rvc('passos'), det: rvc('det'), faq: rvc('faq'), relh: rvc('relh'), rel: rvc('rel'), fac: rvc('fac') },
      setRoot: this.setRoot, setCv: this.setCv, setCta: this.setCta,
      dmDown: this.dmDown, dmMove: this.dmMove, dmUp: this.dmUp, dmKey: this.dmKey,
      dmMsg: s.dmMsg, stCls: (s.dmAlerta ? 'dm-st alerta' : 'dm-st') + (s.stF ? ' f1' : ' f0'), hintCls: s.hint ? 'dm-hint' : 'dm-hint off',
      barCls: s.bar ? 'mbar on' : 'mbar', barHidden: s.bar ? 'false' : 'true'
    };
    return this.demoVals(v);
  }
}
(window.CMG = window.CMG || {}).pages = window.CMG.pages || {};
window.CMG.pages['taca'] = Component;
if (window.CMG.mountAll) window.CMG.mountAll();
})();
